<template>
    <div class="wrapper">
        <div class="m-content-page">


            <div class="container-fluid">
                <router-view></router-view>
            </div>
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import 'motivate-framework/dist/js/m-main.min'
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        components: {

        },
        data() {
            return {

            }
        },
        methods: {
        },
        computed: {
            ...mapGetters('users', [
                'getMe'
            ]),
            ...mapGetters('root', [
                'getMockedCompany'
            ]),

        },
        created() {

        },

    }
</script>
